import {
  Alert,
  Box,
  Button,
  Container,
  FormField,
  Header,
  Input,
  Modal,
  SpaceBetween
} from '@cloudscape-design/components';
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { UserContext } from '../../../context/authContext';
import { UserRow } from './ManageUserRow';
import { PasswordChecker, PasswordMatch } from '../passwordChecker';
import { AddUser } from './AddUser';
import { useAlert } from '../../../context/alertContext';
import { KoruLoading } from '../shared/KoruLoading';

export const ManageUsers = () => {
  // const [users, setUsers] = useState<IUser[]>([]);

  const { auth, users, getUsers, companyAccount, subscription, token } =
    useContext(UserContext);
  const { setAlert, setSubsAlert } = useAlert();
  const [showAddUser, setShowAddUser] = useState<boolean>(false);
  const [showUpdateUser, setShowUpdateUser] = useState(false);
  const [updateIndex, setUpdateIndex] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [showNumbersWarning, setSHowNumbersWarning] = useState<boolean>(false);

  const deactivateUser = async (index: number) => {
    try {
      setLoading(true);
      const reqBody = {
        sub: users[index].sub
      };
      const results = await axios.post(
        `${process.env.REACT_APP_KORU_API}/user?type=deactivateUser`,
        {
          user: reqBody
        },
        auth
      );
      getUsers();
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const error = e as Error;
      setAlert(`${error.message}`, 'error');
    }
  };
  const activateUser = async (index: number) => {
    try {
      setLoading(true);
      const reqBody = {
        sub: users[index].sub
      };
      const results = await axios.post(
        `${process.env.REACT_APP_KORU_API}/user?type=activateUser`,
        {
          user: reqBody
        },
        auth
      );
      getUsers();
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const error = e as Error;
      setAlert(`${error.message}`, 'error');
    }
  };

  useEffect(() => {
    if (showAddUser) {
      // check for numbers
      console.log('subscription info', subscription);
      if (
        users.filter((u) => !u.deactivated).length >=
        Number(subscription?.price.metadata.seats)
      ) {
        setShowAddUser(false);
        setSubsAlert('', 'users');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAddUser]);

  return (
    <>
      {!showAddUser && !showUpdateUser && (
        <Container
          header={
            <Header
              actions={
                <SpaceBetween direction="horizontal" size={'s'}>
                  {/* <Button>Save</Button> */}
                  <Button
                    variant="primary"
                    onClick={() => setShowAddUser(true)}
                  >
                    Add User
                  </Button>
                </SpaceBetween>
              }
            >
              Manage Users
            </Header>
          }
        >
          <SpaceBetween size="l" direction="horizontal">
            {users?.length > 0
              ? users
                  // .sort((a, b) => Number(a.deactivated) - Number(b.deactivated))
                  .map((userRow, index) => {
                    return (
                      <UserRow
                        key={index}
                        index={index}
                        user={userRow}
                        setShowUpdateUser={setShowUpdateUser}
                        setUpdateIndex={setUpdateIndex}
                        activateUser={activateUser}
                        deactivateUser={deactivateUser}
                      />
                    );
                  })
              : null}
          </SpaceBetween>
        </Container>
      )}
      {showAddUser && !showUpdateUser && (
        <AddUser setShowAddUser={setShowAddUser} />
      )}
      {!showAddUser && showUpdateUser && updateIndex !== null && (
        <AddUser
          currentUser={users[updateIndex]}
          type="update"
          setShowUpdateUser={setShowUpdateUser}
        />
      )}
      {loading && <KoruLoading centerText="Updating User" />}
    </>
  );
};
